import React, { useContext } from 'react';
import { useRouter } from 'next/router'
import {
  MagicSvgDispatchContext
} from '../../../context/MagicSvgContext/MagicSvgContext';

import {
  STATUS,
  PAGES,
  magicSvgActions
} from '../../../context/MagicSvgContext/magicSvgReducer';

import { ButtonStyled } from '../magic-svg.styles';

export default function Landing() {
  const { dispatch } = useContext(MagicSvgDispatchContext);
  const router = useRouter();

  const handleClick = () => {
    router.push({
      query: {
        ...router.query,
        page: PAGES.GENERATE,
        shallow: true,
      }
    });

    dispatch({
      type: magicSvgActions.SET_GENERATION_STATUS,
      status: STATUS.SUCCESS,
    });
  };

  return (
    <ButtonStyled
      variant='contained'
      onClick={handleClick}>
      Create a new SVG
    </ButtonStyled>
  );
}
